import { render, staticRenderFns } from "./ListParts.vue?vue&type=template&id=32f9fdbf&"
import script from "./ListParts.vue?vue&type=script&lang=js&"
export * from "./ListParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports